import './Navbar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import auth from '../../firebase';
import { signOut } from 'firebase/auth';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useParams } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';
import Stepper from '../Stepper';
import AccountDropDown from './AccountDropDown';
import HelpCenterDropDown from './HelpCenterDropDown';
import { useCategory } from '../../CategoryContext';

const Navbar = () => {
  const { verticals, isEditor, isAdvancedEditor } = useCategory() || [];
  const activeVerticals =
    verticals && verticals.filter((item) => item.status === 'Joined' || item.status === 'Created');
  const { vertical_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error(error);
    } finally {
      window.location.assign('https://www.simple-platform.com/');
    }
  };

  const isAuthPage =
    location.pathname === '/' ||
    location.pathname.includes('login') ||
    location.pathname.includes('signup') ||
    location.pathname.includes('password') ||
    location.pathname.includes('select-role') ||
    location.pathname.includes('select-sub-role') ||
    location.pathname.includes('select-plan') ||
    location.pathname.includes('subscription-expired') ||
    location.pathname.includes('confirm-downgrade') ||
    location.pathname.includes('review-downgrade') ||
    location.pathname.includes('subscription-success');

  let navigateTo;
  let homePage;
  let profilePage;
  let invitePage;
  let bookmarkPage;
  let workbenchPage;
  let visibilityPage;

  invitePage = `/vertical/${vertical_id}/inviteUsers`;
  profilePage = `/profile/account-details`;
  navigateTo = '/tryrnai';
  homePage = '/tryrnai';
  workbenchPage = '';
  visibilityPage = '';

  if (location.pathname.includes('/vertical/')) {
    bookmarkPage = `/vertical/${vertical_id}/bookmarks`;
    workbenchPage = `/vertical/${vertical_id}/workbench/personal`;
    visibilityPage = `/vertical/${vertical_id}/visibility`;
  } else if (activeVerticals && activeVerticals.length > 0) {
    bookmarkPage = `/vertical/${activeVerticals[0].id}/bookmarks`;
    workbenchPage = `/vertical/${activeVerticals[0].id}/workbench/personal`;
    visibilityPage = `/vertical/${activeVerticals[0].id}/visibility`;
  } else {
    workbenchPage = '/workbench/personal';
    visibilityPage = '/visibility';
  }

  let image = '/logo.svg?v=2';
  let style = { height: '40px', margin: '0 10px' };

  const signupLabels = ['Get started', 'Set up account', 'Choose role', 'Select Plan'];
  const forgotPasswordLabels = ['Enter email', 'Enter new password', 'Password set'];
  const isForgotPassword = location.pathname.includes('password');
  let labels = isForgotPassword ? forgotPasswordLabels : signupLabels;

  let line1b, circle2, line2a, line2b, circle3, line3a, line3b, circle4;
  if (location.pathname.includes('signup')) {
    line1b = true;
    circle2 = true;
  }

  if (location.pathname.includes('select-role') || location.pathname.includes('set-new-password')) {
    line1b = true;
    circle2 = true;
    line2a = true;
  }
  if (
    location.pathname.includes('select-sub-role') ||
    location.pathname.includes('password-changed')
  ) {
    line1b = true;
    circle2 = true;
    line2a = true;
    line2b = true;
    circle3 = true;
  }
  if (location.pathname.includes('select-plan')) {
    line1b = true;
    circle2 = true;
    line2a = true;
    line2b = true;
    circle3 = true;
    line3a = true;
    line3b = true;
    circle4 = true;
  }

  return (
    <>
      <div className="navbar">
        <div style={{ width: '260px' }}>
          {!isAuthPage ? (
            <Link to={homePage}>
              <img src={`${process.env.PUBLIC_URL + image}`} alt="TSP logo" style={style} />
            </Link>
          ) : (
            <img src={`${process.env.PUBLIC_URL + image}`} alt="TSP logo" style={style} />
          )}
        </div>
        {location.pathname.includes('/vertical/') && <SearchBar />}

        {!isAuthPage ? (
          <div className="navbar-items">
            <Link
              className={`navLink ${
                location.pathname.includes('workbench') ? 'navLinkActive' : ''
              }`}
              to={workbenchPage}
            >
              <img
                style={{ height: '24px' }}
                src={`${process.env.PUBLIC_URL + '/navBar/Workbench.svg'}`}
                alt="Workbench"
              />
              <span>Workbenches</span>
            </Link>

            {activeVerticals?.length > 0 && (
              <Link
                className={`navLink ${
                  location.pathname.includes('bookmarks') ? 'navLinkActive' : ''
                }`}
                to={bookmarkPage}
              >
                <img
                  src={`${process.env.PUBLIC_URL + '/navBar/collection.svg'}`}
                  alt="Collection"
                />
                <span>Collection</span>
              </Link>
            )}

            {isAdvancedEditor && (
              <Link
                className={`navLink ${
                  location.pathname.includes('inviteUsers') ? 'navLinkActive' : ''
                }`}
                to={invitePage}
              >
                <img src={`${process.env.PUBLIC_URL + '/navBar/users.svg'}`} alt="Users" />
                <span>Users</span>
              </Link>
            )}

            <Link
              className={`navLink ${location.pathname.includes('tryrnai') ? 'navLinkActive' : ''}`}
              to={navigateTo}
            >
              <img src={`${process.env.PUBLIC_URL + '/navBar/tryRNAI.svg'}`} alt="Try RNAI" />
              <span>Search RNAI</span>
            </Link>

            <Link
              className={`navLink ${
                location.pathname.includes('visibility') ? 'navLinkActive' : ''
              }`}
              to={visibilityPage}
            >
              <img
                src={`${process.env.PUBLIC_URL + '/navBar/visibilityWall.svg'}`}
                alt="Visibility Wall"
                style={{ height: '24px' }}
              />
              <span>Visibility Wall</span>
            </Link>

            <AccountDropDown
              profilePage={profilePage}
              handleLogout={handleLogout}
              verticals={verticals}
            />

            <HelpCenterDropDown />
          </div>
        ) : (
          // <p style={{ margin: "auto" }}>Hi</p>
          (location.pathname.includes('signup') ||
            location.pathname.includes('select') ||
            location.pathname.includes('password')) && (
            <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
              <Stepper
                label1={labels[0]}
                label2={labels[1]}
                label3={labels[2]}
                label4={labels[3]}
                line1b={line1b}
                circle2={circle2}
                line2a={line2a}
                line2b={line2b}
                circle3={circle3}
                line3a={line3a}
                line3b={line3b}
                circle4={circle4}
              />
            </div>
          )
        )}
      </div>

      {(location.pathname.includes('edit') || location.pathname.includes('add')) && (
        <div className="back-button" onClick={() => navigate(-1)}>
          <ArrowBackIcon />
          <span>&nbsp;Back</span>
        </div>
      )}
      {location.pathname.includes('password') && (
        <div
          className="back-button"
          style={{ color: '#1C1B1F' }}
          onClick={() => navigate('/login')}
        >
          <ArrowBackIcon />
          <span>&nbsp;Back to Sign In</span>
        </div>
      )}
    </>
  );
};
export default Navbar;
